import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';

import Home from 'components/app/home';
import MyListings from 'components/app/my-listings';
import ViewListing from 'components/app/view-listing';
import UserProfile from 'components/app/user/profile';
import LandDev from 'components/app/landdev';
import SummaryReportComparison from 'components/app/landdev/summary-report-comparison';
import LivingCarbonGrant from 'components/app/living-carbon-grant';
import LandingPage from 'components/app/landing-page';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';
import ReportingModule from 'components/app/landdev/reporting-module';

const DefaultRoutes = () => {
  return (
    <Routes>
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}

      {/* //--- MainLayout Starts  */}

      <Route element={<MainLayout />}>
        <Route path="/my-listings" element={<MyListings />} />
        <Route path="/listings/:listingId" element={<ViewListing />} />
        <Route path="/user/profile" element={<UserProfile />} />
        <Route path="/land-development" element={<LandDev />} />
        <Route
          path="/summary-report-comparison"
          element={<SummaryReportComparison />}
        />
        <Route path="/reporting-module" element={<ReportingModule />} />
        <Route path="/living-carbon-grant" element={<LivingCarbonGrant />} />

        <Route path="/home" element={<Home />} />
      </Route>

      {/* //--- MainLayout end  */}
      <Route path="/" element={<LandingPage />} />

      {/* <Navigate to="/errors/404" /> */}
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default DefaultRoutes;
